export default __webpack_public_path__ + "static/media/alexandru_face.9d8c0810.jpg";